// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"demo-section_cardContainer__k2SEc","descriptionBox":"demo-section_descriptionBox__kPS_g","timeBadge":"demo-section_timeBadge__J93ZQ"};